export default function toMap(arr) {
  const obj = {}
  arr.forEach(prop => {
    obj[prop] = true
  })
  return obj
}
